import React from 'react';

import { BitDevPlayground } from './pages/bit-dev-playground';
import { GlobalContext } from './templates/global-context';
import { StandalonePlayground } from './pages/standalone-playground';
import qs from 'querystringify';

export default function App() {
	const query = getQuery();
	const { standalone = false, bitId } = query;

	return (
		<GlobalContext>
			{standalone && <StandalonePlayground bitId={bitId} />}
			{!standalone && <BitDevPlayground />}
		</GlobalContext>
	);
}

function getQuery() {
	if (typeof window === 'undefined') return {};
	if (typeof window.location === 'undefined') return {};
	if (typeof window.location.search !== 'string') return {};

	const query = qs.parse(window.location.search) as { [key: string]: string };

	return query;
}
